import { FEATURES } from '../../../config/features';
import { WORKSPACE_IDS } from '../../../auth/workspaces';

export function canAccessProviderAdmin(session) {
  if (!FEATURES.providerAdminConsole) return false;
  if (!session) return false;
  if (session.workspaceId !== WORKSPACE_IDS.PROVIDER && !session.isPlatformAdmin) {
    return false;
  }
  if (session.isPlatformAdmin) return true;
  if (session.membershipRole === 'admin' || session.membershipRole === 'org_admin') {
    return true;
  }
  const permissions = session.permissions || [];
  return permissions.includes('provider_admin:orgs:read');
}
